import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import logo from "../../images/logo.svg";

import AccountButton from "../AccountButton/AccountButton";
import BurgerMenu from "../BurgerMenu/BurgerMenu";
import SettingsButton from "../SettingsButton/SettingsButton";

function Header({isLoggedIn}) {
  const location = useLocation();

  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);

  const handleBurgerMenuClick = () => {
    setIsBurgerMenuOpen(true);
  };
  function closeBurgerMenu() {
    setIsBurgerMenuOpen(false);
  }
  return (
    <>
      <header className="header">
        <Link to={"/"} className="logo-button">
          <img src={logo} alt='Логотип' className='logo logo__header' />
        </Link>

        {/* {isLoggedIn ? ( */}
          <div className="button-container">
            {/*  <Navigation /> */}
            <AccountButton additionalClass={"account-button__header"} />
            <SettingsButton />
          </div>
       {/*  ) : (
          <div className="header-profile">
            <Link to="/signin" className="header__signin-link">
              Войти
            </Link>
            <Link to="/signup" className="header__signup-link">
              Регистрация
            </Link>
          </div>
        )} */}

        {/* <BurgerButton onBurgerMenu={handleBurgerMenuClick} /> */}
      </header>
      <BurgerMenu isBurgerMenuOpen={isBurgerMenuOpen} onClose={closeBurgerMenu} />
    </>
  );
}

export default Header;
